import { Box, Button, ButtonGroup, Dialog, DialogContent, Divider, Paper, Popover, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
import { pcItemColumns, pcTransColumns } from "./columns"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import AddAdvanceDialog from './AddAdvanceDialog';
import ReimbursementDialog from './ReimbursementDialog';
import ChangeDialog from "./ChangeDialog"
import { alertConfirmDelete, alertError, alertSuccess, alertWarning } from "components/Alert"
import { addIdForDataGrid, numberFormat } from "utils"
import { pettyCashApiNm } from "./constant"
import AddItemDialog from "./AddItemDialog"
import { blue, green, purple, red } from "@mui/material/colors"
import dayjs from "dayjs"
import CheckboxFormControl from "components/CheckboxFormControl"
import { initAdvanceDialogData } from "./initData"
import { defaultExpWithDrawId } from "branch/constant/defaultId"
import ComboBox from "components/ComboBox"
import PopoverBarebone from "components/PopoverBarebone"
import { ArrowDropDownRounded, HistoryRounded, LocalShippingRounded, UploadRounded, ViewListRounded } from "resource/muiImport"
import { UserContext } from "contexts/UserContext"
import AddItemTableDialog from "./AddItemTableDialog"
import MatchAdvanceExpenseDialog from "../DriverReceipt/MatchAdvanceExpenseDialog"
import UploadReceiptDialog from "../DriverReceipt/UploadReceiptDialog"
import PersonIcon from '@mui/icons-material/Person';
import FullScreenImageDialog from "components/FullScreenImageDialog/FullScreenImageDialog"
import PettyCashLogDialog from "./PettyCashLogDialog"

let mPCTrnsId = null
let dialogPCTrnsId = null
let hasChange = false
let pcItmId = null
let initChangeDialogData = null
let selectedRowPCItmId = null
let selectedPCTrnsRow = null
let selectedPCItmRow = null

const PettyCashDialog = ({ selectedId, dialogOpen, setDialogOpen, onFinish, lastFilter, getFn, getArgs, updLnkSiteAbbr }) => {
  const { user } = useContext(UserContext)
  const { ax, msData } = useContext(GlobalStateContext)
  const [pcItemDataTable, setPCItemDataTable] = useState([])
  const [pcTrnsDataTable, setPCTrnsDataTable] = useState([])
  const [dialogAddAdvanceOpen, setDialogAddAdvanceOpen] = useState(false)
  const [dialogReimbursementOpen, setDialogReimbursementOpen] = useState(false)
  const [dialogChangeOpen, setDialogChangeOpen] = useState(false)
  const [dialogAddItemTableOpen, setDialogAddItemTableOpen] = useState(false)
  const [prPCTrnsData, setPrPCTrnsData] = useState({ ...initAdvanceDialogData })
  // const [dialogTransOpen, setDialogTransOpen] = useState(false)
  const [dialogItemOpen, setDialogItemOpen] = useState(false)
  const [cashChangePCJnalId, setCashChangePCJnalId] = useState(null)
  const [showIdAnchorEl, setShowIdAnchorEl] = useState(null);
  const [movedPCTrnsId, setMovedPCTrnsId] = useState("")
  const [dialogMatchOpen, setDialogMatchOpen] = useState(false)
  const [matchIsOffice, setMatchIsOffice] = useState(false)
  const [dialogUploadOpen, setDialogUploadOpen] = useState(false)
  const [imgDialogOpen, setImgDialogOpen] = useState(false)
  const [imgUrl, setImgUrl] = useState("")
  const [dialogLogOpen, setDialogLogOpen] = useState(false)

  const handleImageClick = useCallback((url) => {
    setImgUrl(url)
    setImgDialogOpen(true)
  }, [])

  const cashChangeButtonRef = useRef(null)

  const trnsAmnt = useMemo(() => pcTrnsDataTable.reduce((sum, item) => sum + (+item.PayAmnt * (item.InOutTyp === "O" ? 1 : -1)), 0), [pcTrnsDataTable])
  const itemAmnt = useMemo(() => pcItemDataTable.reduce((sum, item) => sum + +item.PayAmnt, 0), [pcItemDataTable])
  const diffAmount = useMemo(() => {
    const found = pcTrnsDataTable.find(row => !row.PrPCTrnsId)
    if (!found) return 0
    if (found.InOutTyp === "O") {
      return +((trnsAmnt - itemAmnt).toFixed(2))
    } else {
      return +(trnsAmnt + itemAmnt).toFixed(2)
    }
  }, [trnsAmnt, itemAmnt, pcTrnsDataTable])

  const diffAmntText = useMemo(() => diffAmount === 0 ? "(-)" : diffAmount < 0 ? "(เงินเพิ่ม)" : "(เงินทอน)", [diffAmount])

  const canDelete = useMemo(() => {
    const foundPr = pcTrnsDataTable.find(row => !row.PrPCTrnsId)
    return foundPr?.PCPrdId ? false : true
  }, [pcTrnsDataTable])

  const setAllData = useCallback((data) => {
    const { pcTransactions, pcItems } = data
    const found = pcTransactions.find(item => item.PrPCTrnsId === null)
    if (!found) {
      alertError("เกิดข้อผิดพลาด ไม่พบการจ่ายเงินหลัก")
      setDialogOpen(false)
      return
    }
    mPCTrnsId = found.PCTrnsId
    setPrPCTrnsData(found ? { ...found } : { ...initAdvanceDialogData })
    setPCTrnsDataTable(addIdForDataGrid(pcTransactions, "PCTrnsId"))
    setPCItemDataTable(addIdForDataGrid(pcItems, "PCItmId"))
  }, [setDialogOpen])

  const handleAddAdvance = useCallback(() => {
    dialogPCTrnsId = null
    setDialogAddAdvanceOpen(true)
  }, [])

  const handleAddReimbursement = useCallback(() => {
    dialogPCTrnsId = null
    setDialogReimbursementOpen(true)
  }, [])

  const handleAddChange = useCallback(() => {
    dialogPCTrnsId = null
    if (!prPCTrnsData) {
      alertError("ไม่มีข้อมูลการจ่ายเงินหลัก ไม่สามารถเพิ่มเงินทอนได้")
      return
    }
    initChangeDialogData = {
      ...prPCTrnsData,
      WhtPrct: 0,
      VatPrct: 0,
      PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      InOutTyp: diffAmount > 0 ? "I" : "O",
      Dscp: diffAmount > 0 ? "เงินทอน" : "เงินเพิ่ม",
      Amnt: Math.abs(diffAmount),
      PrPCTrnsId: prPCTrnsData.PCTrnsId,
      CtrlCd: "",
    }


    // ...row,
    // PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    // InOutTyp: diffAmount > 0 ? "I" : "O",
    // Dscp: diffAmount > 0 ? "เงินทอน" : "เงินเพิ่ม",
    // Amnt: Math.abs(diffAmount),
    // PrPCTrnsId: row.PCTrnsId,
    setDialogChangeOpen(true)
  }, [prPCTrnsData, diffAmount])

  // const handleAddNewChange = useCallback(() => {
  //   dialogPCTrnsId = null
  //   handleAddChange(true)
  // }, [handleAddChange])

  const handleAddPCItem = useCallback(() => {
    pcItmId = null
    if (!prPCTrnsData) {
      alertError("ไม่มีข้อมูลการจ่ายเงินหลัก ไม่สามารถเพิ่มเงินทอนได้")
      return
    }
    setDialogItemOpen(true)
  }, [prPCTrnsData])

  const handleAddItemUseAll = useCallback(() => {
    if (pcTrnsDataTable.length === 0) return
    const pcTrns = pcTrnsDataTable[0]
    const postData = {
      PCItmTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      ExpId: pcTrns.ExpId,
      Amnt: pcTrns.Amnt,
      JobOrdId: pcTrns.JobOrdId,
      AdmAccId: user.AccId,
      IsCost: pcTrns.IsCost,
      WhtPrct: pcTrns.WhtPrct,
      VatPrct: pcTrns.VatPrct,
      IsOwnRcpt: pcTrns.IsOwnRcpt,
      InOutTypItm: pcTrns.InOutTyp,
      SupId: pcTrns.SupId,
      PCTrnsId: pcTrns.PCTrnsId,
      IsShowPrintWht: pcTrns.IsShowPrintWht,
      WhtTypId: pcTrns.WhtTypId,
      WhtPayrTyp: pcTrns.WhtPayrTyp,
      getFn: "getPettyCashDetail",
      getArgs: { PCTrnsId: selectedId },
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    ax.post(pettyCashApiNm.insertPCItem, postData).then(value => {
      if (value.data) {
        setAllData(value.data)
        hasChange = true
      }
    })
  }, [pcTrnsDataTable, ax, user, selectedId, setAllData, updLnkSiteAbbr])

  const onDialogFinish = useCallback((data) => {

    if (data) {
      hasChange = true
      setAllData(data)
    }
  }, [setAllData])

  const handleDeleteTransaction = useCallback(() => {
    const postData = {
      PCTrnsId: mPCTrnsId,
      getFn: getFn,
      getArgs: getArgs || lastFilter,
      UpdLnkSiteAbbr: updLnkSiteAbbr
    }
    alertConfirmDelete("หากมีข้อมูลการทอน หรือข้อมูลข้อมูลใบเสร็จ จะถูกลบด้วย ต้องการลบข้อมูลหรือไม่?", () => {
      ax.post(pettyCashApiNm.deletePCTransaction, postData).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    })
  }, [ax, onFinish, lastFilter, setDialogOpen, getFn, getArgs, updLnkSiteAbbr])


  // const pcItemColumnsMemo = useMemo(() => pcItemColumns({handleEditItmRow, handleRemoveItemRow})
  //   , [handleRemoveItemRow, handleEditItmRow])

  const openItmDialog = useCallback((params, e) => {
    if (params.row.PrIsCmpt) {
      // alertError("ไม่สามารถแก้ไขข้อมูลที่เสร็จสิ้นสมบูรณืแล้ว")
      return
    }
    if (params.field === "ShowDetail" || !params.field) {
      pcItmId = params.id
      if (params.row.CtrlCd) {
        alertError("มีเลขที่ควบคุมเอกสารแล้วไม่สามารถแก้ไขได้")
        return
      }
      setDialogItemOpen(true)
    } else if (params.field === "MvPCTrnsId") {
      selectedPCItmRow = params.row;
      selectedPCTrnsRow = null;
      setShowIdAnchorEl(e.currentTarget);
    }
  }, [])

  const openTrnDialog = useCallback((params, e) => {
    if (params.row.PrIsCmpt) {
      // alertError("ไม่สามารถแก้ไขข้อมูลที่เสร็จสิ้นสมบูรณืแล้ว")
      return
    }
    if (params.field === "ShowDetail" || !params.field) {

      if (params.row.CtrlCd) {
        alertError("มีเลขที่ควบคุมเอกสารแล้วไม่สามารถแก้ไขได้")
        return
      }
      dialogPCTrnsId = params.id
      if (params.row.PrPCTrnsId) {
        initChangeDialogData = null
        setDialogChangeOpen(true)
      } else {
        setDialogAddAdvanceOpen(true)
      }
    } else if (params.field === "MvPCTrnsId") {
      selectedPCTrnsRow = params.row;
      selectedPCItmRow = null;
      setShowIdAnchorEl(e.currentTarget);
    }
  }, [])

  const handleAutoAddChange = useCallback((isWithWithdraw) => () => {
    const found = pcTrnsDataTable.find(item => item.PrPCTrnsId === null)
    if (!found) {
      alertError("ไม่มีข้อมูลการจ่ายเงินหลัก ไม่สามารถเพิ่มเงินทอนได้")
      return
    }

    if (!isWithWithdraw) {
      if (!cashChangePCJnalId) {
        alertError(`กรุณาระบุบัญชี(${diffAmount > 0 ? "เงินทอน" : "เงินเพิ่ม"}) ก่อนทำรายการ`)
        return
      }
      const postData = {
        ...found,
        WhtPrct: 0,
        VatPrct: 0,
        PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        InOutTyp: diffAmount > 0 ? "I" : "O",
        Dscp: diffAmount > 0 ? "เงินทอน" : "เงินเพิ่ม",
        Amnt: Math.abs(diffAmount),
        PCJnlId: cashChangePCJnalId,
        PrPCTrnsId: mPCTrnsId,
        CtrlCd: "",
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      postData.getFn = getFn
      postData.getArgs = getArgs || lastFilter
      ax.post(pettyCashApiNm.insertPCTransaction, postData).then(value => {
        if (value.data) {

          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    } else {
      const postData = {
        PCItmTm: dayjs().format("YYYY-MM-DD HH:mm"), //Coz PayComponent use PayTm for PCItmTm
        ExpId: defaultExpWithDrawId,
        Dscp: "เงินทอนลงเบิก",
        DocNo: "",
        DocDte: null,
        Amnt: Math.abs(diffAmount),
        WhtPrct: 0,
        VatPrct: 0,
        IsOwnRcpt: 1,
        InOutTypItm: found.InOutTyp,
        JobOrdId: found.JobOrdId,
        PCTrnsId: found.PCTrnsId,
        AdmAccId: user.AccId,
        IsCost: 1,
        getFn: getFn,
        getArgs: getArgs || lastFilter,
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      ax.post(pettyCashApiNm.insertPCItem, postData).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    }
  }, [pcTrnsDataTable, diffAmount, ax, onFinish, lastFilter, setDialogOpen, cashChangePCJnalId
    , getFn, getArgs, user.AccId, updLnkSiteAbbr])

  const handleIsCmptChange = useCallback((e) => {
    const postData = {
      PCTrnsId: mPCTrnsId,
      IsCmpt: e.target.checked ? 1 : 0,
      getFn: "getPettyCashDetail",
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updateIsCmpt, postData).then(value => {
      if (value.data) {
        setPrPCTrnsData(o => ({ ...o, IsCmpt: e.target.checked ? 1 : 0 }))
        setAllData(value.data)
        hasChange = true
      }
    })
  }, [ax, setAllData, updLnkSiteAbbr])

  const handleIsRdyXpssChange = useCallback((e) => {
    const postData = {
      PCTrnsId: mPCTrnsId,
      IsRdyXpss: e.target.checked ? 1 : 0,
      getFn: "getPettyCashDetail",
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updateIsRdyXpss, postData).then(value => {
      if (value.data) {
        setPrPCTrnsData(o => ({ ...o, IsRdyXpss: e.target.checked ? 1 : 0 }))
        setAllData(value.data)
        hasChange = true
      }
    })
  }, [ax, setAllData, updLnkSiteAbbr])
  const handleOpenAddItemTable = useCallback(() => {
    setDialogAddItemTableOpen(true)
  }, [])

  const handleOpenMatchDialog = useCallback(() => {
    setMatchIsOffice(false)
    setDialogMatchOpen(true)
  }, [])

  const handleOpenOfficeMatchDialog = useCallback(() => {
    setMatchIsOffice(true)
    setDialogMatchOpen(true)
  }, [])

  const handleMatchFinish = useCallback(() => {
    ax.post(pettyCashApiNm.getPettyCashDetail, { PCTrnsId: mPCTrnsId, UpdLnkSiteAbbr: updLnkSiteAbbr }).then(value => {
      if (value.data) {
        setAllData(value.data)
        hasChange = true
      }
    })
  }, [ax, setAllData, updLnkSiteAbbr])

  const handleChangeIsCost = useCallback((id, isCost) => {
    const postData = {
      PCItmId: id,
      ColValues: {
        IsCost: isCost,
        IsOwnRcpt: isCost === 1 ? 1: 0
      },
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updatePCItemCols, postData).then(value => {
      if (value.data) {
        setPCItemDataTable(o => {
          const newData = o.map(item => {
            if (item.PCItmId === id) {
              return { ...item, IsCost: isCost, IsOwnRcpt: isCost === 1 ? 1 : 0 }
            }
            return item
          })
          return newData
        })
        hasChange = true
      }
    })
  }, [ax, updLnkSiteAbbr])

  const handleChangeIsOwnRcpt = useCallback((id, isOwnRcpt) => {
    const postData = {
      PCItmId: id,
      ColValues: {
        IsOwnRcpt: isOwnRcpt
      },
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updatePCItemCols, postData).then(value => {
      if (value.data) {
        setPCItemDataTable(o => {
          const newData = o.map(item => {
            if (item.PCItmId === id) {
              return { ...item, IsOwnRcpt: isOwnRcpt }
            }
            return item
          })
          return newData
        })
        hasChange = true
      }
    })
  }, [ax, updLnkSiteAbbr])
  const handlePopoverSearchOpen = useCallback((id) => () => {
    selectedRowPCItmId = id
  }, [])

  const handleSelectJobOrder = useCallback((item) => {
    if (!selectedRowPCItmId) {
      return
    }
    const postData = {
      PCItmId: selectedRowPCItmId,
      ColValues: {
        JobOrdId: item.JobOrdId
      },
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updatePCItemCols, postData).then(res => {
      if (res.data) {

        setPCItemDataTable(o => {

          const result = [...o]
          const foundIndex = result.findIndex(r => r.id === selectedRowPCItmId)
          if (foundIndex !== -1) {
            result[foundIndex].JobOrdId = item.JobOrdId
            result[foundIndex].Loc = `${item.TakePlc || ""}-${item.Loc || ""}-${item.RtnPlc || ""}`
          }
          return result
        })
      }
    })
  }, [ax, updLnkSiteAbbr])

  const handlePCTransEditCommit = useCallback(({ id, field, value }) => {
    const postData = {
      PCTrnsId: id,
      ColValues: {
        [field]: value
      },
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    ax.post(pettyCashApiNm.updatePCTransactionCols, postData).then(res => {
      if (res.data) {
        setPCItemDataTable(o => {
          const newData = o.map(item => {
            if (item.id === id) {
              return { ...item, [field]: value }
            }
            return item
          })
          return newData
        })
      }
    })
  }, [ax, updLnkSiteAbbr])

  const handleCellEditCommit = useCallback(({ id, field, value }) => {
    const row = pcItemDataTable.find(item => item.PCItmId === id)
    if (!["Dscp", "Rmk", "CtrlCd", "WhtPayrTyp"].includes(field) && row.CtrlCd) {
      alertError("มีเลขที่ควบคุมเอกสารแล้วไม่สามารถแก้ไขได้")
      return
    }
    if (field === "JobOrdId") {
      if (value === null || value === "") {
        const postData = {
          PCItmId: id,
          ColValues: {
            JobOrdId: null
          },
          UpdLnkSiteAbbr: updLnkSiteAbbr,
        }
        ax.post(pettyCashApiNm.updatePCItemCols, postData).then(res => {
          if (res.data) {
            setPCItemDataTable(o => {
              const newData = o.map(item => {
                if (item.PCItmId === id) {
                  return { ...item, JobOrdId: null, Loc: "" }
                }
                return item
              })
              return newData
            })
            hasChange = true
          }
        })
        return

      }
      ax.post(pettyCashApiNm.getJobOrderLocation, { JobOrdId: value, UpdLnkSiteAbbr: updLnkSiteAbbr }, false).then(res => {
        if (res.data) {
          if (res.data.length !== 1) {
            alertError("ไม่พบข้อมูล เลขที่ใบงานนี้ (ข้อมูลยังไม่ถูกบันทึก)")
            return
          }
          const data = res.data[0]
          const postData = {
            PCItmId: id,
            ColValues: {
              JobOrdId: data.JobOrdId,
            },
            UpdLnkSiteAbbr: updLnkSiteAbbr,
          }
          ax.post(pettyCashApiNm.updatePCItemCols, postData, false).then(res2 => {
            if (res2.data) {
              setPCItemDataTable(o => {
                const result = [...o]
                const foundIndex = result.findIndex(item => item.PCItmId === id)
                result[foundIndex] = {
                  ...result[foundIndex],
                  JobOrdId: data.JobOrdId,
                  Loc: `${data.TakePlc || ""}-${data.Loc || ""}-${data.RtnPlc || ""}`,
                }
                return result
              })
              hasChange = true
            }
          })
        }
      })
    } else {
      let valueToSet = value
      if (field === "DocDte") {
        if (!value) {
          valueToSet = null
        } else {
          valueToSet = dayjs(value).format("YYYY-MM-DD")
          if (!dayjs(value).isValid()) {
            alertWarning("รูปแบบวันที่ไม่ถูกต้อง")
          } else {
            const valueYear = dayjs(value).year()
            if (valueYear > dayjs().year() + 1 || valueYear < dayjs().year() - 1) {
              alertWarning("คำเตือน: ปีของวันที่ที่ระบุอาจไม่ถูกต้อง")
            }
          }
        }
      }
      if (field === "DocNo" && value) {
        ax.post(pettyCashApiNm.checkDocNoExist, { DocNo: value }, false).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              alertWarning(`เลขที่เอกสาร ${value} มีอยู่ในระบบแล้ว กรุณาตรวจสอบ`)
            }
          }
        })
      }
      const postData = {
        PCItmId: id,
        ColValues: {
          [field]: valueToSet
        },
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      ax.post(pettyCashApiNm.updatePCItemCols, postData).then(res => {
        if (res.data) {
          setPCItemDataTable(o => {
            const newData = o.map(item => {
              if (item.id === id) {
                return { ...item, [field]: valueToSet }
              }
              return item
            })
            return newData
          })
          hasChange = true
        }
      })
    }
  }, [ax, pcItemDataTable, updLnkSiteAbbr])

  const handleDeleteFile = useCallback((file) => {
    alertConfirmDelete(() => {
      const postData = {
        PCTrnsFileId: file.PCTrnsFileId,
        FileNm: file.FileNm,
        getFn: "getPettyCashDetail",
        PCTrnsId: mPCTrnsId,
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      ax.post(pettyCashApiNm.deleteFilePCTransaction, postData).then(value => {
        if (value.data) {
          alertSuccess("ลบไฟล์เรียบร้อยแล้ว")
          setAllData(value.data)
        }

      })
    })
  }, [ax, setAllData, updLnkSiteAbbr])

  const handleDeleteFilePCItm = useCallback((file) => {
    alertConfirmDelete(() => {
      const postData = {
        PCItmFileId: file.PCItmFileId,
        FileNm: file.FileNm,
        getFn: "getPettyCashDetail",
        PCItmId: file.PCItmId,
        PCTrnsId: mPCTrnsId,
        UpdLnkSiteAbbr: updLnkSiteAbbr,
      }
      ax.post(pettyCashApiNm.deleteFilePCItem, postData).then(value => {
        if (value.data) {
          alertSuccess("ลบไฟล์เรียบร้อยแล้ว")
          setAllData(value.data)
        }

      })
    })
  }, [ax, setAllData, updLnkSiteAbbr])

  const onFileUploadSuccess = useCallback(() => {
    ax.post(pettyCashApiNm.getPettyCashDetail, { PCTrnsId: selectedId || mPCTrnsId, UpdLnkSiteAbbr: updLnkSiteAbbr }).then(value => {
      if (value.data) {
        setAllData(value.data)
      }
    })
  }, [ax, selectedId, setAllData, updLnkSiteAbbr])

  const handleMovePCTrnsId = useCallback(() => {
    if (!selectedPCTrnsRow && !selectedPCItmRow) {
      alertError("กรุณาเลือกข้อมูลที่ต้องการย้าย")
      return
    }
    console.log("movedPCTrnsId:: ", movedPCTrnsId, movedPCTrnsId === 0);
    if (movedPCTrnsId === "0") {
      if(selectedPCTrnsRow){
        if (!selectedPCTrnsRow.PrPCTrnsId) {
          alertError("รายการนี้เป็นการจ่ายเงินหลักอยู่แล้ว ไม่สามารถแยกเป็นรายการหลักใหม่ได้")
          return
        }
        const postData = {
          PCTrnsId: selectedPCTrnsRow.PCTrnsId,
          PrPCTrnsId: selectedPCTrnsRow.PrPCTrnsId,
          getFn: "getPettyCashDetail",
          getArgs: { PCTrnsId: mPCTrnsId }
        }
        ax.post(pettyCashApiNm.movePCTrsnsactionToMain, postData).then(value => {
          if (value.data) {
            alertSuccess("ย้ายข้อมูลสำเร็จ")
            setAllData(value.data)
            setShowIdAnchorEl(null)
            setMovedPCTrnsId("")
            hasChange = true
          }
        })
      }
      if(selectedPCItmRow){
        // if(!msData.driverCombo.find(d=>d.id === selectedPCItmRow.AdmAccId)){
        //   alertError("สามารถย้ายรายการออกได้เฉพาะรายการที่ พขร. เป็นผู้บันทึกเท่านั้น")
        //   return
        // }
        const postData = {
          PCItmId: selectedPCItmRow.PCItmId,
          getFn: "getPettyCashDetail",
          getArgs: { PCTrnsId: mPCTrnsId },
          ColValues: {
            PCTrnsId: null
          }
        }
        ax.post(pettyCashApiNm.updatePCItemCols, postData).then(value => {
          if (value.data) {
            alertSuccess("ย้ายข้อมูลสำเร็จ")
            setAllData(value.data)
            setShowIdAnchorEl(null)
            setMovedPCTrnsId("")
            hasChange = true
          }
        })
      }
    } else {
      const table = selectedPCTrnsRow ? "pc_transaction" : "pc_item"
      const postData = {
        table,
        PrPCTrnsId: +movedPCTrnsId,
        PCTrnsIds: selectedPCTrnsRow ? [selectedPCTrnsRow.PCTrnsId] : [],
        PCItmIds: selectedPCItmRow ? [selectedPCItmRow.PCItmId] : [],
        getFn: "getPettyCashDetail",
        getArgs: { PCTrnsId: selectedPCTrnsRow?.PrPCTrnsId ? selectedPCTrnsRow.PrPCTrnsId : movedPCTrnsId }
      }
      ax.post(pettyCashApiNm.movePCTrsnsaction, postData).then(value => {
        if (value.data) {
          alertSuccess("ย้ายข้อมูลสำเร็จ")
          setAllData(value.data)
          setShowIdAnchorEl(null)
          setMovedPCTrnsId("")
          hasChange = true
        }
      })
    }
  }, [ax, movedPCTrnsId, setAllData])

  const pcTransColumnsMemo = useMemo(() => {
    return pcTransColumns({ handleDeleteFile, onFileUploadSuccess, onImageClick: handleImageClick })
  }, [handleDeleteFile, onFileUploadSuccess, handleImageClick])

  const pcItemColumnsMemo = useMemo(() => {
    // console.log("pcItemColumnsMemo pcTrnsData::", prPCTrnsData)
    return pcItemColumns({
      handleChangeIsCost, handleChangeIsOwnRcpt, handlePopoverSearchOpen, handleSelectJobOrder
      , handleDeleteFile: handleDeleteFilePCItm, onFileUploadSuccess, onImageClick: handleImageClick
      , suggestDrvId: prPCTrnsData?.UsrAccId
      , suggestPOIIds: [prPCTrnsData?.TakePOIId, prPCTrnsData?.RtnPOIId].filter(id => id)
    })
  }, [handleChangeIsCost, handleChangeIsOwnRcpt, handlePopoverSearchOpen, handleSelectJobOrder, handleDeleteFilePCItm
    , onFileUploadSuccess, handleImageClick, prPCTrnsData])

  const pcTrnsDataForAddItemDialogMemo = useMemo(() => {
    return { ...prPCTrnsData, PCPrdId: null, CtrlCd: "" }
  }, [prPCTrnsData])

  useEffect(() => {
    if (dialogOpen) {
      hasChange = false
      if (selectedId) {
        const postData = {
          PCTrnsId: selectedId,
          UpdLnkSiteAbbr: updLnkSiteAbbr
        }
        ax.post(pettyCashApiNm.getPettyCashDetail, postData).then(value => {
          if (value.data) {
            mPCTrnsId = selectedId
            setAllData(value.data)
          }
        })
      }
    } else {
      setPCItemDataTable([])
      setPCTrnsDataTable([])
      setPrPCTrnsData({ ...initAdvanceDialogData })
      if (hasChange) {

        hasChange = false
        onFinish()
      }
    }
  }, [dialogOpen, ax, selectedId, onFinish, setAllData, updLnkSiteAbbr])

  // console.log("pcTransDataTable::", pcTrnsDataTable)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title1"
      fullWidth
      PaperProps={{
        sx: { maxWidth: 2400 }
      }}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="1.7-1 รายละเอียดการใช้เงิน"
        onDeleteClick={canDelete ? handleDeleteTransaction : null}
      >
        <Button sx={{ml: 1}} variant="contained" color="secondary" disabled={!prPCTrnsData.PCTrnsId}
          onClick={() => setDialogLogOpen(true)}><HistoryRounded sx={{mr: 1}}/> ประวัติ</Button>
      </DialogHeader>
      <DialogContent>

        <BoxFC pt={2} sx={{ gap: 1 }} height={600}>
          <BoxFR>
            <Typography fontWeight="bold">จ่าย-รับเงิน</Typography>

            <Button variant='contained' size='small' disabled={prPCTrnsData.IsCmpt ? true : false || pcTrnsDataTable.length > 0}
              onClick={handleAddAdvance}>จ่ายเงินล่วงหน้า</Button>
            <Button variant='contained' size='small' disabled={prPCTrnsData.IsCmpt ? true : false || pcTrnsDataTable.length > 0}
              onClick={handleAddReimbursement}>เบิกค่าใช้จ่าย(มี/ไม่มี ใบเสร็จ)-รับเงิน</Button>
            <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt ? true : false || pcTrnsDataTable.length === 0}
              onClick={handleAddChange} >เพิ่มเงินทอน-เงินเพิ่ม</Button>
            <Box flex={1} />
            <Typography ><strong>รวมเงิน :</strong>{trnsAmnt === 0 ? "" : trnsAmnt > 0 ? "(จ่าย)" : "(รับ)"} {numberFormat(Math.abs(trnsAmnt))} บาท</Typography>
          </BoxFR>
          <Box flex={1} >
            <DataGridCellExpand
              hideToolbar
              hideFooter
              rows={pcTrnsDataTable}
              columns={pcTransColumnsMemo}
              onCellClick={openTrnDialog}
              onCellEditCommit={handlePCTransEditCommit}
            // onRowDoubleClick={openTrnDialog}
            />
          </Box>
          <Divider sx={{ width: "80%", alignSelf: "center" }} />
          <BoxFR pt={1}>
            <Typography fontWeight="bold">รับใบเสร็จ-การใช้เงิน</Typography>
            <ButtonGroup disabled={prPCTrnsData.IsCmpt || pcTrnsDataTable.length === 0 ? true : false}>
              <Button variant="contained" size="small"
                onClick={handleAddPCItem} >เพิ่มการใช้เงิน-รับใบเสร็จ</Button>
              <Button variant="contained" size="small" onClick={handleOpenAddItemTable}>
                <ViewListRounded />
              </Button>
            </ButtonGroup>
            <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt
              || pcTrnsDataTable.length !== 1 || pcItemDataTable.length > 0 ? true : false}
              onClick={handleAddItemUseAll} >ใช้พอดี</Button>
            <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt === 1 || !prPCTrnsData.PCTrnsId? true:false}
              onClick={handleOpenMatchDialog}>
              <LocalShippingRounded sx={{mr: 1}} />
              รายการใบเสร็จจาก พขร.
            </Button>
            <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt === 1 || !prPCTrnsData.PCTrnsId? true:false}
              onClick={handleOpenOfficeMatchDialog}>
              <PersonIcon sx={{mr: 1}} />
              รายการใบเสร็จจาก Office
            </Button>
            <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt === 1 || !prPCTrnsData.PCTrnsId? true:false}
              onClick={() => setDialogUploadOpen(true)}>
              <UploadRounded sx={{mr: 1}} />
              อัพโหลดไฟล์ใบเสร็จ
            </Button>
            <Box flex={1} />
            <Typography ><strong>รวมเงิน :</strong> {numberFormat(itemAmnt)} บาท</Typography>
          </BoxFR>
          <Box flex={1} sx={{
            "& .cost": { bgcolor: red[50] },
            "& .income": { bgcolor: green[50] },
            "& .own-rcpt": { bgcolor: blue[50] },
            "& .cus-rcpt": { bgcolor: green[50] },
          }}>
            <DataGridCellExpand
              hideToolbar
              hideFooter
              rows={pcItemDataTable}
              columns={pcItemColumnsMemo}
              onCellClick={openItmDialog}
              onCellEditCommit={handleCellEditCommit}
            // onRowDoubleClick={openItmDialog}
            />
          </Box>
          <BoxFR>
            <Typography fontWeight="bold">เงินส่วนต่าง </Typography>
            <Typography color={diffAmount === 0 ? "black" : diffAmount > 0 ? red[800] : green[800]} px={1} py={0.5}
              bgcolor={diffAmount === 0 ? "transparent" : diffAmount > 0 ? red[50] : green[50]}>
              {diffAmount === 0 ? "" : diffAmount < 0 ? "(เงินเพิ่ม)" : "(เงินทอน)"}
              {numberFormat(Math.abs(diffAmount))}
            </Typography>
            <Typography> บาท</Typography>
            <ButtonGroup>
              <Button variant="contained" size="small" disabled={prPCTrnsData.IsCmpt ? true : false || diffAmount === 0}
                onClick={handleAutoAddChange(false)} >บันทึกส่วนต่างเป็น{diffAmntText}
              </Button>
              <PopoverBarebone
                ref={cashChangeButtonRef}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                component={
                  <Button size="small" variant="contained" sx={{ minWidth: 0, width: 15, p: 0, height: "100%" }}
                    disabled={prPCTrnsData.IsCmpt ? true : false || diffAmount === 0}>
                    <ArrowDropDownRounded />
                  </Button>
                }
              >
                <Paper sx={{ p: 0.5 }}>
                  <BoxFC sx={{ gap: 1 }}>
                    <Button size="small" variant='outlined' onClick={handleAutoAddChange(true)}>เงินทอนลงเบิก</Button>
                  </BoxFC>
                </Paper>
              </PopoverBarebone>
            </ButtonGroup>
            <ComboBox sx={{ width: 150 }} options={msData.pcJournalCombo} label={`บัญชี${diffAmntText}`}
              disabled={prPCTrnsData.IsCmpt ? true : false || diffAmount === 0}
              selectedId={cashChangePCJnalId}
              setSelectedId={(id) => setCashChangePCJnalId(id)}
            />
            <CheckboxFormControl sx={{ py: 0.5, px: 2, borderRadius: 1, bgcolor: prPCTrnsData.IsCmpt ? green[100] : null }}
              label="รายการเสร็จสิ้นสมบูรณ์" checked={prPCTrnsData.IsCmpt ? true : false}
              onChange={handleIsCmptChange} disabled={diffAmount !== 0 && !prPCTrnsData.IsCmpt} />

            <CheckboxFormControl sx={{ py: 0.5, px: 2, borderRadius: 1, bgcolor: prPCTrnsData.IsRdyXpss ? purple[100] : null }}
              label="ตรวจสอบเรียบร้อย" checked={prPCTrnsData.IsRdyXpss ? true : false}
              onChange={handleIsRdyXpssChange} disabled={!prPCTrnsData.IsCmpt} />
          </BoxFR>
        </BoxFC>
        <Popover
          open={Boolean(showIdAnchorEl)}
          anchorEl={showIdAnchorEl}
          onClose={(e) => setShowIdAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}>
          <Paper sx={{ p: 1 }}>
            <BoxFC sx={{ gap: 0 }}>
              <BoxFR>
                <TextField label="Transaction Id" variant="outlined" size="small"
                  value={movedPCTrnsId} type="number"
                  onChange={(e) => setMovedPCTrnsId(e.target.value)}></TextField>
                <Button variant="contained" onClick={handleMovePCTrnsId}>ย้าย</Button>
              </BoxFR>
              {selectedPCTrnsRow ?
                <Typography variant="caption" color="text.secondary">*ใส่เลข 0 เพื่อย้ายไปยังการจ่ายเงินหลักใหม่</Typography>
                : 
                selectedPCItmRow  ?
                  <Typography variant="caption" color="text.secondary">*ใส่เลข 0 เพื่อย้ายออกจากการจ่ายเงิน</Typography>
                  : null
              }
            </BoxFC>
          </Paper>
        </Popover>
        <AddAdvanceDialog
          pcTrnsId={dialogPCTrnsId}
          dialogOpen={dialogAddAdvanceOpen}
          setDialogOpen={setDialogAddAdvanceOpen}
          onFinish={onDialogFinish}
          getFn="getPettyCashDetail"
          updLnkSiteAbbr={updLnkSiteAbbr} />
        <ReimbursementDialog
          dialogOpen={dialogReimbursementOpen}
          setDialogOpen={setDialogReimbursementOpen}
          onFinish={onDialogFinish}
          getFn="getPettyCashDetail"
          updLnkSiteAbbr={updLnkSiteAbbr} />
        <ChangeDialog
          initData={initChangeDialogData}
          pcTrnsId={dialogPCTrnsId}
          prPCTrnsId={mPCTrnsId}
          prPCTrnsData={prPCTrnsData}
          dialogOpen={dialogChangeOpen}
          setDialogOpen={setDialogChangeOpen}
          onFinish={onDialogFinish}
          updLnkSiteAbbr={updLnkSiteAbbr} />
        <AddItemDialog
          maxAmount={Math.abs(diffAmount)}
          pcItmId={pcItmId}
          pcTrnsId={mPCTrnsId}
          prPCTrnsData={pcTrnsDataForAddItemDialogMemo}
          dialogOpen={dialogItemOpen}
          setDialogOpen={setDialogItemOpen}
          onFinish={onDialogFinish}
          updLnkSiteAbbr={updLnkSiteAbbr} />
        <AddItemTableDialog
          pcTrnsData={prPCTrnsData}
          dialogOpen={dialogAddItemTableOpen}
          setDialogOpen={setDialogAddItemTableOpen}
          onFinish={onDialogFinish}
          updLnkSiteAbbr={updLnkSiteAbbr} />
        <MatchAdvanceExpenseDialog
          dialogOpen={dialogMatchOpen}
          setDialogOpen={setDialogMatchOpen}
          selectedDrvId={prPCTrnsData.UsrAccId}
          pcTrnsId={mPCTrnsId}
          isOffice={matchIsOffice}
          onFinish={handleMatchFinish} />
        <UploadReceiptDialog
          dialogOpen={dialogUploadOpen}
          setDialogOpen={setDialogUploadOpen}
          pcTrnsId={mPCTrnsId}
          fallbackJobOrdId={prPCTrnsData.JobOrdId}
          onFinish={handleMatchFinish} />
        <FullScreenImageDialog
          linkUrl={imgUrl}
          dialogOpen={imgDialogOpen}
          setDialogOpen={setImgDialogOpen} />
        <PettyCashLogDialog
          pcTrnsId={prPCTrnsData.PCTrnsId}
          dialogOpen={dialogLogOpen}
          setDialogOpen={setDialogLogOpen}
          updLnkSiteAbbr={updLnkSiteAbbr} />

      </DialogContent>
      <DialogFooter okText="" cancelText="ปิด"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(PettyCashDialog)